let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dEIjM")).then(() => parcelRequire('1DgiC'));